<template>
  <div class="alllive" style="min-height: calc(100vh - 100px);">
    <section class="course-listing-banner-section gradiant-banner">
      <b-container>
        <b-navbar toggleable="md" type="dark" class="course-listing-banner-nav">
          <b-navbar-brand href="#">All Live Courses</b-navbar-brand>
          <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

          <!--<b-collapse id="nav-collapse" is-nav>-->
          <!--&lt;!&ndash; Right aligned nav items &ndash;&gt;-->
          <!--<filter-bar :filterData="filterData" @applyFilter="applyFilter"></filter-bar>-->
          <!--</b-collapse>-->
        </b-navbar>
      </b-container>
    </section>
    <section>
      <b-container>
        <h1
          class="heading squiggly-line-color"
          v-if="todayLiveCourses.length > 0"
        >
          Today's Live Courses
        </h1>
        <b-row>
          <!--            loop here!-->
          <b-col
            v-for="courses in todayLiveCourses"
            :key="courses.course_id"
            cols="12"
            lg="4"
            class="px-3 py-3"
          >
            <course_banner :live-course="courses"></course_banner>
          </b-col>
        </b-row>
        <h1
          class="heading squiggly-line-color"
          v-if="upcomingLiveCourses.length > 0"
        >
          Upcoming Live Courses
        </h1>
        <b-row>
          <!--            loop here!-->
          <b-col
            v-for="courses in upcomingLiveCourses"
            :key="courses.course_id"
            cols="12"
            lg="4"
            class="px-3 py-3"
          >
            <course_banner :live-course="courses"></course_banner>
          </b-col>
        </b-row>
        <h1
          class="heading squiggly-line-color"
          v-if="previousLiveCourses.length > 0"
        >
          Previous Live Courses
        </h1>
        <b-row>
          <!--            loop here!-->
          <b-col
            v-for="courses in previousLiveCourses"
            :key="courses.course_id"
            cols="12"
            lg="4"
            class="px-3 py-3"
          >
            <course_banner :live-course="courses"></course_banner>
          </b-col>
        </b-row>
      </b-container>
    </section>
  </div>
</template>

<script>
import FilterBar from "../components/Templates/FilterBar.vue";
import { mapGetters } from "vuex";
import Course_banner from "../components/Templates/CourseBanner";
import { videoApi } from "../services/videoApi";

export default {
  name: "LiveListing",
  components: {
    Course_banner,
    FilterBar
  },
  data() {
    return {
      todayLiveCourses: [],
      previousLiveCourses: [],
      upcomingLiveCourses: [],
      previous: "previous",
      today: "today",
      upcoming: "upcoming",
      filterData: {}
    };
  },
  computed: {
    ...mapGetters("user", ["isAuthenticated"]),
    ...mapGetters("teacher", ["getFollowingTeachers"])
  },
  methods: {
    applyFilter(courseData) {
      this.liveCourses = courseData;
    }
  },
  mounted() {
    videoApi.getAllLiveCourses().then(res => {
      this.todayLiveCourses = res.data.liveCourseResponse.todayLiveCourses;
      this.previousLiveCourses =
        res.data.liveCourseResponse.previousLiveCourses;
      this.upcomingLiveCourses =
        res.data.liveCourseResponse.upcomingLiveCourses;
    });
  }
};
</script>

<style scoped></style>
